import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-show-text',
  templateUrl: './modal-show-text.component.html',
  styleUrls: ['./modal-show-text.component.css']
})
export class ModalShowTextComponent implements OnInit {

  @ViewChild('textPopup') popup: TemplateRef<any>;

  text = '';
  titleText = '';
  buttonConfirmText = '';
  disabledBody = false;
  showCloseButton = true;
  limitchar = 0;

  showModal = false;

  onClose: Subject<string>;

  partialForm = undefined;

  constructor(private _bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.onClose = new Subject();
  }

  public showTextModal(title: string, body: string, txtconfirm: string, disabledBody?: boolean, showCloseButton?: boolean, limitchar: number = 3000): void {
    this.titleText = title;
    this.text = body;
    this.buttonConfirmText = txtconfirm;
    this.showModal = true;
    this.disabledBody = disabledBody ? disabledBody : false;
    this.partialForm = new FormGroup({
      txteditor: new FormControl({ value: body, disabled: this.disabledBody }, Validators.required),
    });

    this.showCloseButton = showCloseButton !== undefined ? showCloseButton : true;
    this.limitchar = limitchar;
  }

  public onConfirm(): void {
    this.showModal = false;
    this.onClose.next(this.text);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.showModal = false;
    this.onClose.next('');
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.showModal = false;
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
